<template>
  <div id="nav-bar" class="nav-wrapper">
    <div class="route-name">
      <bread-crumb></bread-crumb>
    </div>
    <div class="navbar" mode="horizontal">
      <el-button type="text" class="ai-chat-btn" @click="onAIChatBtnClick">
        <img :src="robotIcon" class="ai-chat-icon" />AI助理
      </el-button>
      <theme-switch></theme-switch>
      <user-avatar></user-avatar>
    </div>
  </div>
</template>

<script>
import robotIcon from '@/assets/images/chatrobot/robot-icon.png'
import { mapActions, mapState } from 'vuex'
import ThemeSwitch from './ThemeSwitch'
import UserAvatar from './UserAvatar'
import BreadCrumb from './Breadcrumb'

export default {
  name: 'Navbar',
  components: {
    ThemeSwitch,
    UserAvatar,
    BreadCrumb
  },
  data() {
    return {
      robotIcon
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    onAIChatBtnClick() {
      this.$emit('showAIChat')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'nav-wrapper',
  (
    --navbar-bg-color: #051434,
    --navbar-box-shadow-color: rgba(69, 194, 255, 0.18),
    --navbar-bread-crumb-color: #b6c8d0,
    --navbar-bread-crumb-last-bread-color: #ffffff,
    --navbar-bread-crumb-seperator-color: #b6c8d0,
    --navbar-theme-switch-core-color: #535f87,
    --navbar-theme-switch-core-btn-color: #051434,
    --navbar-avatar-username: #fff,
    --navbar-avatar-dropdown: #fff,
    --navbar-ai-chat-background: linear-gradient(279deg, #a5f 1.22%, #45c2ff 100%),
    --navbar-ai-chat-border-color: rgba(255, 255, 255, 0.13)
  ),
  (
    --navbar-bg-color: #ffffff,
    --navbar-box-shadow-color: transparent,
    --navbar-bread-crumb-color: #5A6973,
    --navbar-bread-crumb-last-bread-color: #122836,
    --navbar-bread-crumb-seperator-color: #5A6973,
    --navbar-theme-switch-core-color: #edf1fb,
    --navbar-theme-switch-core-btn-color: #88939a,
    --navbar-avatar-username: #122836,
    --navbar-avatar-dropdown: #122836,
    --navbar-ai-chat-background: linear-gradient(279deg, #a5f 1.22%, #45c2ff 100%),
    --navbar-ai-chat-border-color: rgba(255, 255, 255, 0.13)
  )
);
.nav-wrapper {
  @include adaptation(
    (
      --navbar-padding: 0 32px 0 16px,
      --navbar-fontsize: 14px,
      --navbar-box-shadow: 0px 6px 46px 0px,
      --navbar-bread-crumb-height: 56px,
      --navbar-bread-crumb-fontsize: 12px,
      --navbar-bread-crumb-seperator-fontsize: 12px,
      --navbar-bread-crumb-seperator-margin: 0 8px,
      --navbar-bread-crumb-icon-margin-right: 4px,
      --navbar-bread-crumb-icon-size: 16px,
      --navbar-theme-switch-width: 28px,
      --navbar-theme-switch-height: 16px,
      --navbar-theme-switch-border-width: 1px,
      --navbar-theme-switch-btn-offset: 1px,
      --navbar-avatar-area-height: 56px,
      --navbar-avatar-margin-left: 24px,
      --navbar-avatar-name-margin: 0 8px,
      --navbar-avatar-name-fontsize: 14px,
      --navbar-avatar-dropdown-fontsize: 16px,
      --navbar-ai-chat-btn-margin-right: 24px,
      --navbar-ai-chat-btn-icon-margin-right: 8px,
      --navbar-ai-chat-icon-size: 16px,
      --navbar-ai-chat-height: 32px,
      --navbar-ai-chat-border-radius: 16px,
      --navbar-ai-chat-padding: 5px 12px
    )
  );
  --navbar-theme-switch-btn-size: calc(
    var(--navbar-theme-switch-height) - var(--navbar-theme-switch-border-width) * 2 -
      var(--navbar-theme-switch-btn-offset) * 2
  );
  --navbar-theme-switch-btn-after-margin-left: calc(
    0px - var(--navbar-theme-switch-btn-size) - var(--navbar-theme-switch-btn-offset)
  );

  display: flex;
  align-items: center;
  justify-content: space-between;
  height: var(--base-navbar-height);
  background: var(--navbar-bg-color);
  padding: var(--navbar-padding);
  box-shadow: var(--navbar-box-shadow) var(--navbar-box-shadow-color);
  z-index: 200;
  position: relative;

  .route-name {
    font-size: var(--navbar-bread-crumb-fontsize);
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: var(--navbar-bread-crumb-color);
  }

  .navbar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: var(--navbar-fontsize);
    height: var(--base-navbar-height);
    box-sizing: border-box;

    .ai-chat-btn {
      margin-right: var(--navbar-ai-chat-btn-margin-right);
      color: var(--base-color-white);
      border: var(--base-border-width) solid var(--navbar-ai-chat-border-color);
      background: var(--navbar-ai-chat-background);
      border-radius: var(--navbar-ai-chat-border-radius);
      height: var(--navbar-ai-chat-height);
      padding: var(--navbar-ai-chat-padding);
      background-origin: border-box;

      /deep/span {
        display: flex;
        align-items: center;
      }

      .ai-chat-icon {
        width: var(--navbar-ai-chat-icon-size);
        height: var(--navbar-ai-chat-icon-size);
        margin-right: var(--navbar-ai-chat-btn-icon-margin-right);
      }

      &:hover {
        opacity: 0.8;
      }
    }

    .avatar-area {
      margin-left: var(--navbar-avatar-margin-left);
    }
  }
}
</style>
